<template lang="pug">
    div(class="text-danger-dark bg-danger-light p-3")
        XIcon(@click='$store.dispatch("clearGeneralErrors")' class="w-4 h-4 cursor-pointer fill-current text-danger-dark float-right")
        div(
            v-for="error, index in errors"
            :key="index"
            class="mb-2"
        )
            p(class="mb-2 font-bold")
                template(v-if="error.header !== undefined") {{ error.header }}
                template(v-else) Sorry, something went wrong.  Please refresh this page and try again.

            span(v-if="error && error.message") {{ error.message }}
            span(v-else) If the problem persists please call {{ $config.runtime.theme.phoneNumbers.general }}
                br
                strong
                    | Error:
                |  {{ error }}

            span(v-if="error.stack") &nbsp;: {{ error.stack }}

</template>
<script>
import XIcon from '@/assets/common/x?inline'

export default {
    components: { XIcon },
    computed: {
        errors() {
            return this.$store.state.generalErrors
        },
    },
    watch: {
        $route() {
            if (this.errors.length > 0) {
                this.$store.dispatch('clearGeneralErrors')
            }
        },
        errors(newVal) {
            if (newVal.length > 0) window.scrollTo(0, 0)
        },
    },
}
</script>
